import { Cookies } from 'react-cookie';

import { AddImageToClientValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PatchImageToClientProps {
  clientId: number;
  info: AddImageToClientValues;
}

export const patchImageToClient = async ({ clientId, info }: PatchImageToClientProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const formData = new FormData();
  formData.append('image', info.image);

  const response = await axiosInterceptor.patch(`/clients/${clientId}/add-image/`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
